import { FormItemTypes } from '@bimser/core';
import DataGrid from '..';

export function setDefaultDataGridProps(this: DataGrid) {
	this.controlType = FormItemTypes.EControlTypes.DataGrid;
	this.columns = [];
	this.rows = [];

	this.caption.position = 'top';
	this.exportToExcel = false;
	this.gridLines = 'horizontal';

	this.dataSource = {
		name: '',
		valueExpr: '',
		displayExpr: [],
		displayFormat: '',
		runAtServer: false,
		parameters: [],
		useClientCachedData: true
	};
	this.dataSourceType = 'dynamic';
	this.columnSettings = {
		orderable: false,
		resizeable: false,
		showColumnChooser: false,
		resizingMode: null
	};
	this.detailRow = {
		enabled: false
	};
	this.editing = {
		mode: 'row',
		enabled: false,
		showAddCommand: false,
		showDeleteCommand: false,
		showEditCommand: false
	};
	this.filtering = {
		enabled: false,
		showOperationChooser: false,
		headerFilterEnabled: false
	};
	this.grouping = {
		enabled: false
	};
	this.paging = {
		enabled: true,
		currentPage: 1,
		pageSize: 10,
		pagingSizes: [10, 20, 30, 40]
	};
	this.searching = {
		enabled: false
	};
	this.selection = {
		enabled: false,
		mode: 'single',
		selectAllMode: 'page',
		showSelectAll: false,
		showCheckBoxesMode: 'onClick',
		disabledValueColumnName: '',
		disabledValueMatchers: []
	};
	this.sorting = {
		enabled: false,
		allSortingColumns: true,
		mode: 'none'
	};
	this.alternateColor = {
		color: 'rgba(33, 150, 243, 0.05)',
		enabled: true
	};
	this.toolbarActionButtons = [];
	this.virtualScrolling = false;
	this.gridBorder = true;
	this.hiddenRowColumnName = null;
	this.hiddenRowValueMatchers = null;
	this.__columns = [];
	this.batchOperations = [];
	if (this.columns.length) {
		this.__editingColumnsValues = this.columns.map(x => ({
			name: x.name,
			value: null,
			rowValue: null
		}));
	}
	this.selectedRowKeys = [];
	this.wordWrapEnabled = false;
	this.columnHidingEnabled = false;
	this.rowDragging = {
		enabled: false,
		showDragIcons: false
	};
	this.saveMode = 'form';
	this.cacheSettingsEnabled = false;
	this.pendingEdit = false;
}
